/* eslint-disable custom/no-hardcoded-colors */
import { styled, theme } from 'design-system';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import React from 'react';

import { Journal } from '../../resources/journal';

const ConnectingLineContainer = styled('div', {
  position: 'relative',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const Container = styled('div', {
  width: '610px',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
});

const Section = styled('div', {
  backgroundColor: '#F6FAFF',
  borderRadius: '20px',
  border: '1px solid rgba(206, 234, 247, 1)',
  position: 'relative',
  padding: '40px 24px 24px 24px',
});

const FreeReportSection = styled(Section, {});

const AiServicesSection = styled(Section, {});

const HumanServicesSection = styled(Section, {});

// eslint-disable-next-line custom/no-hardcoded-colors
const SectionHeader = styled('div', {
  position: 'absolute',
  top: '-15px',
  left: '24px',
  width: '180px',
  height: '30px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#CCE0FF',
  borderRadius: '15px',
  fontWeight: '600',
  fontSize: '16px',
  color: theme.colors.blue12,
  padding: '3px 10px',
  gap: '10px',
});

const ConnectingLine = styled('div', {
  left: '50%',
  transform: 'translateX(-50%)',
  width: '1px',
  backgroundColor: '#A6C3FF',
  zIndex: 1,
});

const Card = styled('div', {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '16px',
  padding: '6px',
  backgroundColor: 'transparent',
  position: 'relative',
});

const IconContainer = styled('div', {
  width: '54px',
  height: '54px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
});

const Content = styled('div', {
  flex: 1,
});

const Title = styled('div', {
  fontSize: '16px',
  fontWeight: '600',
  color: theme.colors.blue12.toString(),
  marginBottom: '8px',
});

const Description = styled('div', {
  fontSize: '14px',
  color: theme.colors.blue12.toString(),
  lineHeight: '1.5',
});

// const InternalConnector = styled('div', {
//   position: 'absolute',
//   left: '33px',
//   width: '1px',
//   height: '46px',
//   borderLeft: '1px dashed #A6C3FF',
//   zIndex: 1,
// });

export const AtWorkCardComponentNew = ({
  langCheckCount,
  techCheckCount,
  hasHumanServicesAddon = false,
  journal,
  aiEditingPrice,
  isPeerPilotEnabled = true,
}: {
  langCheckCount: number;
  techCheckCount: number;
  hasHumanServicesAddon?: boolean;
  journal: Journal;
  aiEditingPrice?: string | number;
  isPeerPilotEnabled?: boolean;
}) => {
  const { t } = useTranslation('homepage');
  return (
    <Container>
      <FreeReportSection>
        <SectionHeader>
          {t('v2_new_content.free_report', 'Free report')}
        </SectionHeader>

        {/* {langCheckCount > 0 && (
          <>
            <Card css={{ position: 'relative', marginBottom: '16px' }}>
              <IconContainer
                css={{
                  backgroundColor: theme.colors.blue3.toString(),
                }}
              >
                <Image
                  src="/language-addon.svg"
                  width={66}
                  height={66}
                  alt="Language checks"
                />
              </IconContainer>
              <Content>
                <Title>
                  {langCheckCount}{' '}
                  {t('v2_new_content.language_checks', 'Language Checks')}
                </Title>
                <Description>
                  {t(
                    'v2_new_content.checks_for_language_quality',
                    'Checks for language quality including grammar, readability, writing mechanics, and academic vocabulary.',
                  )}
                </Description>
              </Content>
              <InternalConnector
                css={{
                  top: '60px',
                }}
              />
            </Card>
          </>
        )} */}

        {/* {techCheckCount > 0 && (
          <>
            <Card css={{ position: 'relative', marginBottom: '16px' }}>
              <IconContainer
                css={{
                  backgroundColor: theme.colors.blue3.toString(),
                }}
              >
                <Image
                  src="/technical-addon.svg"
                  width={66}
                  height={66}
                  alt="Technical checks"
                />
              </IconContainer>
              <Content>
                <Title>
                  {techCheckCount}{' '}
                  {t('v2_new_content.technical_checks', 'Technical Checks')}
                </Title>
                <Description>
                  {t(
                    'v2_new_content.checks_for_technical_requirements',
                    'Checks for technical requirements related to references, disclosures, limits, structure, figures, tables, etc.',
                  )}
                </Description>
              </Content>
              <InternalConnector
                css={{
                  top: '60px',
                }}
              />
            </Card>
          </>
        )} */}

        <Card css={{ position: 'relative' }}>
          <IconContainer
            css={{
              backgroundColor: theme.colors.yellow2.toString(),
            }}
          >
            <Image
              src="/detailed-report-addon.svg"
              width={66}
              height={66}
              alt="Detailed report"
            />
          </IconContainer>
          <Content>
            <Title>
              {t('v2_new_content.detailed_report', 'Detailed Report')}
            </Title>
            <Description>
              {journal.publisher.slug === 'paperpal' ||
              journal.publisher.slug === 'gjd-journal-finder' ||
              journal.publisher.slug === 'editage-cn' ||
              journal.publisher.slug === 'editage-us'
                ? t(
                    'v2_new_content.detailed_report_description_paperpal',
                    'Get a detailed report summarizing findings of the {{count}} checks to help prepare your manuscript for submission - free of cost.',
                    { count: langCheckCount + techCheckCount },
                  )
                : t(
                    'v2_new_content.detailed_report_description',
                    'Get a detailed report summarizing findings of the {{count}} checks to help prepare your manuscript for submission - free of cost for authors submitting to this journal.',
                    { count: langCheckCount + techCheckCount },
                  )}
            </Description>
          </Content>
        </Card>
      </FreeReportSection>
      <ConnectingLineContainer>
        <ConnectingLine
          css={{
            height: '100%',
          }}
        />
      </ConnectingLineContainer>

      <AiServicesSection>
        <SectionHeader>
          {t('v2_new_content.ai_services', 'AI Services')}
        </SectionHeader>

        <Card>
          <IconContainer
            css={{
              backgroundColor: theme.colors.red2.toString(),
            }}
          >
            <Image
              src="/ai-edited-addon.svg"
              width={66}
              height={66}
              alt="AI edited file"
            />
          </IconContainer>
          <Content>
            <Title>
              {isPeerPilotEnabled
                ? t(
                    'v2_new_content.ai_edited_file_downloadable',
                    'Preflight Pro (AI-Edited File + PeerPilot Report)',
                  )
                : t(
                    'v2_new_content.ai_edited_file_downloadable_without_peerpilot',
                    'AI-Edited File with all fixes (Downloadable)',
                  )}
            </Title>
            <Description>
              {isPeerPilotEnabled
                ? t(
                    'v2_new_content.ai_edited_file_description',
                    'Get the comprehensive package for a one-time fee of {{price}}. Download the AI-Edited File with language fixes and receive the PeerPilot content rigor review report. Includes 30 days of free rechecks for the edited file.',
                    { price: aiEditingPrice },
                  )
                : t(
                    'v2_new_content.ai_edited_file_description_without_peerpilot',
                    'Download an edited version of your manuscript with all language fixes and get free unlimited rechecks for a one-time fee.',
                    { price: aiEditingPrice },
                  )}
            </Description>
          </Content>
        </Card>
      </AiServicesSection>
      {hasHumanServicesAddon && (
        <ConnectingLineContainer>
          <ConnectingLine
            css={{
              height: '100%',
            }}
          />
        </ConnectingLineContainer>
      )}
      {hasHumanServicesAddon && (
        <HumanServicesSection>
          <SectionHeader>
            {t('v2_new_content.human_services', 'Human Services')}
          </SectionHeader>

          <Card>
            <IconContainer
              css={{
                backgroundColor: theme.colors.blue2.toString(),
              }}
            >
              <Image
                src="/human-services-addon.svg"
                width={66}
                height={66}
                alt="Human expert services"
              />
            </IconContainer>
            <Content>
              <Title>
                {t(
                  'v2_new_content.human_expert_services',
                  'Human Expert Services',
                )}
              </Title>
              <Description>
                {t(
                  'v2_new_content.expert_services_description',
                  'Experts help you navigate submission requirements, format your manuscript, and review language via human proofreading support',
                )}
              </Description>
            </Content>
          </Card>
        </HumanServicesSection>
      )}
    </Container>
  );
};
